<section class="relative md:py-24 py-16 overflow-hidden">

  <div class="container">
    <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
        <div class="lg:col-span-5 md:col-span-6">
            <div class="relative">
                <div class="relative">
                    <img [src]="pagedata.foto1" class="lg:w-[400px] w-[280px] rounded-md shadow dark:shadow-gray-700" alt="">
                    <!--<div class="absolute top-0 translate-y-2/4 ltr:right-0 rtl:left-0 text-center">
                        <a href="#!" data-type="youtube" data-id="yba7hPeTSjk" class="lightbox h-20 w-20 rounded-full shadow-lg dark:shadow-gray-700 inline-flex items-center justify-center bg-white dark:bg-slate-900 text-emerald-600 dark:text-white">
                            <i class="mdi mdi-play inline-flex items-center justify-center text-2xl"></i>
                        </a>
                    </div>-->
                </div>
                <div class="absolute ltr:md:-right-5 ltr:right-0 rtl:md:-left-5 rtl:left-0 -bottom-16">
                    <img [src]="pagedata.foto2" class="lg:w-[280px] w-[200px] border-8 border-white dark:border-slate-900 rounded-md shadow dark:shadow-gray-700" alt="">
                </div>
            </div>
        </div>

        <div class="lg:col-span-7 md:col-span-6 mt-14 md:mt-0">
            <div class="ltr:lg:ml-5 rtl:lg:mr-5">
                <h3 class="mb-6 md:text-[26px] text-2xl md:leading-normal leading-normal font-semibold">Praktisch</h3>

                <p class="text-slate-400 max-w-xl">Hieronder kan u algemene informatie vinden over onze praktijken, afspraken en tarieven.</p>

                <div *ngFor="let faq of faqs;let i=index;" id="accordion-collapseone" data-accordion="collapse" class="mt-8">
                    <div class="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden">
                        <h2 class="text-base font-semibold" [id]="'accordion-collapse-heading-' + i">
                            <button type="button" class="flex justify-between items-center p-5 w-full font-semibold text-left hover:bg-earth-dark/20" [attr.data-accordion-target]="'#accordion-collapse-body-' + i" aria-expanded="false" [attr.aria-controls]="'accordion-collapse-body-' + i">
                                <span>{{ faq.vraag }}</span>
                                <!--<svg data-accordion-icon class="w-4 h-4 rotate-180 shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                                </svg>-->
                            </button>
                        </h2>
                        <div [id]="'accordion-collapse-body-' + i" class="hidden" [attr.aria-labelledby]="'accordion-collapse-heading-' + i">
                            <div class="p-5">
                                <p class="text-slate-400 dark:text-gray-400 answer" [innerHTML]="faq.antwoord | mdtohtml"></p>
                                <img class="w-5/5 mx-auto mt-8 border-2 border-black/80 a" *ngIf="faq?.foto" [src]="faq.foto" /><br />
                                <img class="w-5/5 mx-auto mt-8 border-2 border-black/80 b" *ngIf="faq?.foto2" [src]="faq.foto2" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><!--end grid-->
  </div><!--end container-->
</section>
